import styled, { css } from 'styled-components';
import Image from '@components/image';
import LinkComponent from '@components/link';
import { headerHeight } from '@components/header/header.styled';
import { PhotographyHeroProps } from './index';

export const Header = styled.header<Pick<PhotographyHeroProps, 'backgroundImage'>>`
  ${({ theme, backgroundImage }) => {
    const bgImageUrl = backgroundImage?.url;
    return css`
      display: flex;
      flex-direction: column;
      position: relative;
      width: 100%;
      margin: 0;
      background-color: ${theme.backgroundColors.dark};
      ${bgImageUrl
        ? css`
            background-image: url('${bgImageUrl}');
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
          `
        : ''}
      padding-top: ${headerHeight};

      @media only screen and (max-width: ${theme.breakpoints.lg}) {
        padding-top: 5rem;
      }

      @media only screen and (max-width: ${theme.breakpoints.md}) {
        padding-top: 4rem;
      }
    `;
  }}
`;

export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1.5rem;
  width: 100%;
  max-width: 32rem;
`;

export const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 30rem;
`;

export const EyebrowWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    column-gap: 0.5rem;

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      justify-content: center;
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      column-gap: 0.375rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      justify-content: flex-start;
    }
  `}
`;

export const StyledImage = styled(Image)`
  z-index: 1;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const TextContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    gap: 4rem;
    align-items: flex-start;
    width: 100%;
    justify-content: space-between;

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      align-items: flex-start;
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      flex-direction: column;
      gap: 1rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      padding-right: 0rem;
    }
  `}
`;

export const Content = styled.div<PhotographyHeroProps>`
  ${({ theme, image }) => css`
    position: relative;
    display: flex;
    flex-direction: column;
    z-index: 1;
    width: 100%;
    padding: 3.5rem 0;
    align-items: flex-start;

    @media only screen and (max-width: ${theme.breakpoints.xl}) {
      padding: 3.5rem 0;
      align-items: flex-start;
    }

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      padding: 3rem 0;
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      align-items: flex-start;
    }

    ${image?.url
      ? css`
          justify-content: center;

          @media only screen and (max-width: ${theme.breakpoints.lg}) {
            align-items: flex-start;
          }

          @media only screen and (max-width: ${theme.breakpoints.sm}) {
            align-items: flex-start;
            row-gap: 2rem;
            padding: 3rem 0;
          }
        `
      : css`
          max-width: 52rem;
          align-items: center;
        `}
  `}
`;

export const StyledWrapper = styled.div<PhotographyHeroProps>`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 0rem;
    padding: 0;

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
    }
  `}
`;

export const LinkButton = styled(LinkComponent)<PhotographyHeroProps>`
  ${({ theme }) => css`
    background-color: ${theme.colors.primary};
    color: ${theme.colors.secondary};
    font-size: 1.0625rem;
    transition: transform 0.125s ease-in-out;

    svg {
      fill: ${theme.colors.secondary};
      stroke: ${theme.colors.secondary};
    }

    &:hover {
      background-color: ${theme.colors.white};
      color: ${theme.colors.secondary};
      transform: scale(1.05);

      svg {
        fill: ${theme.colors.secondary};
        stroke: ${theme.colors.secondary};
      }
    }
  `}
`;

export const ImageWrapper = styled.div`
  ${({ theme }) => css`
    gap: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-height: 28rem;
    position: relative;
    width: 100%;
    overflow: hidden;
    margin-right: -1rem;

    .animate-wrapper {
      height: 100%;
    }

    @media only screen and (max-width: ${theme.breakpoints.xl}) {
      max-height: 26rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      max-height: 24rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      justify-content: flex-start;
      width: 100vw;
      margin-right: 0;
      align-self: center;
      max-height: 18rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      align-self: center;
    }
  `}
`;
